import PropTypes from 'prop-types';
import {
	HiOutlineArchiveBox,
	HiOutlineArrowUpTray,
	HiOutlineArrowUturnLeft,
	HiOutlineArrowUturnRight,
	HiOutlineArrowsUpDown,
	HiOutlineBars2,
	HiOutlineBars3,
	HiOutlineBars3BottomLeft,
	HiOutlineBuildingOffice2,
	HiOutlineCalendar,
	HiOutlineCheck,
	HiOutlineCheckCircle,
	HiOutlineChevronDown,
	HiOutlineChevronLeft,
	HiOutlineChevronRight,
	HiOutlineChevronUp,
	HiOutlineCog6Tooth,
	HiOutlineEnvelope,
	HiOutlineExclamationTriangle,
	HiOutlineEye,
	HiOutlineEyeSlash,
	HiOutlineGlobeAlt,
	HiOutlineInformationCircle,
	HiOutlineListBullet,
	HiOutlineMapPin,
	HiOutlineMinus,
	HiOutlinePencilSquare,
	HiOutlinePhoto,
	HiOutlinePhone,
	HiOutlinePlus,
	HiOutlineQrCode,
	HiOutlineSquares2X2,
	HiOutlineSquaresPlus,
	HiOutlineSparkles,
	HiOutlineTrash,
	HiOutlineUser,
	HiOutlineUserGroup,
	HiOutlineViewColumns,
	HiOutlineXMark,
} from 'react-icons/hi2';

const ICONS = {
	alignLeft: HiOutlineBars3BottomLeft,
	alert: HiOutlineExclamationTriangle,
	archive: HiOutlineArchiveBox,
	building: HiOutlineBuildingOffice2,
	calendar: HiOutlineCalendar,
	check: HiOutlineCheck,
	checkCircle: HiOutlineCheckCircle,
	chevronDown: HiOutlineChevronDown,
	chevronLeft: HiOutlineChevronLeft,
	chevronRight: HiOutlineChevronRight,
	chevronUp: HiOutlineChevronUp,
	columns: HiOutlineViewColumns,
	edit: HiOutlinePencilSquare,
	expand: HiOutlineArrowsUpDown,
	eye: HiOutlineEye,
	eyeOff: HiOutlineEyeSlash,
	globe: HiOutlineGlobeAlt,
	grip: HiOutlineBars2,
	heading: HiOutlineBars3,
	image: HiOutlinePhoto,
	info: HiOutlineInformationCircle,
	layers: HiOutlineSquares2X2,
	layout: HiOutlineSquaresPlus,
	list: HiOutlineListBullet,
	mail: HiOutlineEnvelope,
	mapPin: HiOutlineMapPin,
	minus: HiOutlineMinus,
	package: HiOutlineSquaresPlus,
	phone: HiOutlinePhone,
	plus: HiOutlinePlus,
	qrCode: HiOutlineQrCode,
	redo: HiOutlineArrowUturnRight,
	settings: HiOutlineCog6Tooth,
	sparkles: HiOutlineSparkles,
	trash: HiOutlineTrash,
	undo: HiOutlineArrowUturnLeft,
	upload: HiOutlineArrowUpTray,
	user: HiOutlineUser,
	users: HiOutlineUserGroup,
	x: HiOutlineXMark,
};

/**
 * Renders a named icon from the postmailing builder's icon set.
 * Falls back to an info icon when the name is unknown.
 *
 * @param {{ name: string, size?: number, className?: string, style?: object }} props
 * @returns {React.ReactNode}
 */
export default function EditorIcon({ name, size = 14, className = '', style }) {
	const Comp = ICONS[name] || HiOutlineInformationCircle;
	return <Comp size={size} className={className} style={style} />;
}

EditorIcon.propTypes = {
	name: PropTypes.string.isRequired,
	size: PropTypes.number,
	className: PropTypes.string,
	style: PropTypes.object,
};
